import { Box, Card, Tabs, Tab, useMediaQuery, useTheme, Grid } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { setMultiLanguageData, setPreviousQuestionId } from "../../redux/actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import BuilderBucksBalance from "./BuilderBucksBalance";
import { English } from "../../constant/EnglishFallback";
import AdContainer from "../common/AdContainer";

function Rewardlayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.RewardStore || {};

  const {
    TEXT_EARN = English?.RewardStore?.TEXT_EARN,
    TEXT_HISTORY = English?.RewardStore?.TEXT_HISTORY
  } = LanguageData;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // Map paths to tabs
  const pathToTabMap = {
    "/reward-store": "earn-builderbucks",
    "/reward-store/earn-builderbucks": "earn-builderbucks",
    "/reward-store/account-activity": "account-activity",
    "/reward-store/earn-builderbucks/earn-rewards": "earn-builderbucks"
  };

  const activeTab = pathToTabMap[location.pathname];

  useEffect(() => {
    if (location?.state?.from === "from-notification") {
      const { notificationId } = location.state;
      dispatch(setPreviousQuestionId(Number(notificationId)));
    }
  }, [location, dispatch]);

  const handleTabChange = (event, newValue) => {
    if (newValue === "earn-builderbucks") {
      navigate("/reward-store/earn-builderbucks");
    } else if (newValue === "account-activity") {
      navigate("/reward-store/account-activity");
    }
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Grid size={{ xs: 12, md: 3 }}>
        <BuilderBucksBalance />
      </Grid>
      {/* Tabs */}
      {(!location?.pathname.includes("/earn-rewards") && !location.pathname.includes("/my-store")) && <Tabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}
      >
        <Tab label={TEXT_EARN} value="earn-builderbucks" />
        <Tab label={TEXT_HISTORY} value="account-activity" />
      </Tabs>}

      {/* Page content */}
      <Card className="main-content-card">
        <Outlet />
        <AdContainer />
      </Card>
    </Box>
  );
}

export default Rewardlayout;
